import { controls,grouped } from "../controls";
const employee_leave_balances = {
label: "Employee Leave Balances",
pageLabel: "Employee Leave Balances",starting: true,url: "autogen",
formActions: { edit: { allow: true },delete:{allow:true} },
pageType: "history",
filter:[
]
,form:[
...controls.displayText({ tab: "general", label: "Privilege",star:false}),
...controls.numberOnly({ tab: "general",  placeHolder: "", name: "privilege",maxlength:200}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Casual",star:false}),
...controls.numberOnly({ tab: "general",  placeHolder: "", name: "casual",maxlength:200}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Medical",star:false}),
...controls.numberOnly({ tab: "general",  placeHolder: "", name: "medical",maxlength:200}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Maternity",star:false}),
...controls.numberOnly({ tab: "general",  placeHolder: "", name: "maternity",maxlength:200}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Marriage Leave",star:false}),
...controls.numberOnly({ tab: "general",  placeHolder: "", name: "marriage_leave",maxlength:200}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Paternity Leave",star:false}),
...controls.numberOnly({ tab: "general",  placeHolder: "", name: "paternity_leave",maxlength:200}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Without Pay",star:false}),
...controls.numberOnly({ tab: "general",  placeHolder: "", name: "without_pay",maxlength:200}),
...controls.displayText({ tab: "general", label: ""}),
]
,history:{
perPage: 10,
reportHeader: "Employee Leave Balances",
pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
clickable: true,
displayColumns: [
{Header: "Sr",type: "autoinc",accessor: "srno",align: "center",width: 30},
{Header: "Privilege",accessor: "privilege",},
{Header: "Casual",accessor: "casual",},
{Header: "Medical",accessor: "medical",},
{Header: "Maternity",accessor: "maternity",},
{Header: "Marriage Leave",accessor: "marriage_leave",},
{Header: "Paternity Leave",accessor: "paternity_leave",},
{Header: "Without Pay",accessor: "without_pay",},
]}};
export default employee_leave_balances;